<script>
	export let fill = "currentColor";
	export let stroke_width = 1.5;
</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	width="100%"
	height="100%"
	viewBox="0 0 24 24"
	{fill}
	stroke="currentColor"
	stroke-width={`${stroke_width}`}
	stroke-linecap="round"
	stroke-linejoin="round"
	class="feather feather-square"
>
	<rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
</svg>
